import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'cc-account',
  templateUrl: './account.component.html',
  styleUrls: ['./account.component.scss']
})
export class AccountComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
